import { getLong, logicalKeys, setLong, type Storage } from '../platform/storage'
import { KEY, WINDOWS_PREFIX, yearMonthOf } from './keys'

/**
 * История окон бодрствования — моменты нажатия «Проснулся». Нужна календарю.
 * Хранится помесячно (`windows_2026_09`), как и заметки.
 */

function parseMonth(raw: string | null): number[] {
  if (raw === null) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is number => typeof v === 'number') : []
  } catch {
    return []
  }
}

export async function loadWindowsMonth(storage: Storage, yearMonth: string): Promise<number[]> {
  return parseMonth(await getLong(storage, KEY.windowsMonth(yearMonth)))
}

/** Все начала окон по всем месяцам, по возрастанию. */
export async function loadWindows(storage: Storage): Promise<number[]> {
  const months = logicalKeys(await storage.keys()).filter((k) => k.startsWith(WINDOWS_PREFIX))
  const all: number[] = []
  for (const key of months) all.push(...parseMonth(await getLong(storage, key)))
  return all.sort((a, b) => a - b)
}

/** Запоминает начало окна; повторная запись того же момента ничего не меняет. */
export async function logWindow(storage: Storage, startMillis: number): Promise<void> {
  const month = yearMonthOf(startMillis)
  const existing = await loadWindowsMonth(storage, month)
  if (existing.includes(startMillis)) return
  const updated = [...existing, startMillis].sort((a, b) => a - b)
  await setLong(storage, KEY.windowsMonth(month), JSON.stringify(updated))
}
